export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";